import { toNumberDisplayValue } from "@intentsify/utils";
import { useQuery } from "@tanstack/react-query";
import { StatCardsContainer } from "components";
import { Props } from "../../../../WebAnalytics.types";
import { getStatistics } from "../../Visualization.requests";

export const Statistics = ({
  pixelId,
  accountView,
  campaignId,
  startDate,
  endDate,
  accountsIds,
  visitedPages,
  includeIspTraffic,
  includeKnownBotTraffic,
  includePotentialBotTraffic,
  personas,
}: Props) => {
  const { data: statistics, isFetching: isFetchingStatistics } = useQuery({
    queryKey: [
      "webAnalyticsStatistics",
      pixelId,
      accountView,
      campaignId,
      startDate,
      endDate,
      accountsIds,
      visitedPages,
      includeIspTraffic,
      includeKnownBotTraffic,
      includePotentialBotTraffic,
      personas,
    ],
    queryFn: () =>
      getStatistics(pixelId, {
        accountView,
        campaignId,
        startDate,
        endDate,
        accountsIds,
        visitedPages,
        includeIspTraffic,
        includeKnownBotTraffic,
        includePotentialBotTraffic,
        personas,
      }),
  });

  return (
    <StatCardsContainer
      mb={4}
      items={[
        {
          isLoading: isFetchingStatistics,
          title: "Accounts visited",
          value: statistics?.cards.accountsVisited,
          valueFormatter: (value) => `${toNumberDisplayValue(value)}`,
          titleTooltip:
            "Number of companies who have visited your website within the time frame selected.",
          noValueMessage: "No historical data available.",
          previousPeriodLabel: "vs Previous Week:",
          previousPeriodChange: statistics?.trends.accountsVisited || 0,
        },
        {
          isLoading: isFetchingStatistics,
          title: "Unique visitors",
          value: statistics?.cards.uniqueVisitors,
          valueFormatter: (value) => `${toNumberDisplayValue(value)}`,
          titleTooltip:
            "Number of unique users who have visited your website within the time frame selected.",
          noValueMessage: "No historical data available.",
          previousPeriodLabel: "vs Previous Week:",
          previousPeriodChange: statistics?.trends.uniqueVisitors || 0,
        },
        {
          isLoading: isFetchingStatistics,
          title: "Total Page Views",
          value: statistics?.cards.totalPageViews,
          valueFormatter: (value) => `${toNumberDisplayValue(value)}`,
          titleTooltip:
            "Amount of webpages visited within your website that is tagged with our Intentsify tag within the time frame selected.",
          noValueMessage: "No historical data available.",
          previousPeriodLabel: "vs Previous Week:",
          previousPeriodChange: statistics?.trends.totalPageViews || 0,
        },
      ]}
    />
  );
};
